/** @type {import('./index').NetworkConfig} */
const twitter = {
  name: 'X',
  sort: 6,
  baseUrl: 'https://x.com/',
  domains: ['x.com', 'twitter.com'],
  supported: false,
  color: '#000000',
  hasVideoContent: false,
  supportsEmbed: false,
  requiresReferrer: false,
  profileUrlPattern: /^https:\/\/(?:twitter\.com|x\.com)\/(?!home(?:\/|$)|explore(?:\/|$)|notifications(?:\/|$)|messages(?:\/|$)|account(?:\/|$))([a-zA-Z0-9_.]+)\/?$/,
};

export default twitter;
